import { render } from "./VerifyDeposit.vue?vue&type=template&id=e200e93e"
import script from "./VerifyDeposit.vue?vue&type=script&lang=js"
export * from "./VerifyDeposit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__